import {
  ExportComponent,
  TabExportType,
} from "@features/assessments-feature/types/TabTypes";
import {
  assessmentTabIds,
  assessmentTabViewMode,
} from "@features/assessments-feature/constants";
import MaturityChartCardExport from "@features/assessments-feature/components/assessment-export/MaturityChartCardExport";
import MaturityChartGridExport from "@features/assessments-feature/components/assessment-export/MaturityChartGridExport";
import SummaryExport from "@features/assessments-feature/components/assessment-export/SummaryExport";
import TargetMaturityBreakdownExport from "@features/assessments-feature/components/assessment-export/TargetMaturityBreakdownExport";
import PrioritiesRecsTableExport from "@features/assessments-feature/components/assessment-export/PrioritiesRecsTableExport";
import PrioritiesRecsListExport from "@features/assessments-feature/components/assessment-export/PrioritiesRecsListExport";
import CapabilityChangesExport from "../components/assessment-export/CapabilityChangesExport";
import { VsemRecommendationStatus } from "@lib/ShiOneClient";

export const assessmentTabsAndExports: TabExportType[] = [
  {
    tabId: assessmentTabIds.overview,
    tabName: "Overview",
    componentsToPrint: [
      {
        name: "Summary",
        component: SummaryExport,
      },
      {
        name: "Target Maturity Breakdown",
        component: TargetMaturityBreakdownExport,
      },
    ],
  },
  {
    tabId: assessmentTabIds.maturityChart,
    tabName: "Maturity Chart",
    componentsToPrint: [
      {
        name: "Card view",
        component: MaturityChartCardExport,
      },
      {
        name: "Table view",
        component: MaturityChartGridExport,
      },
    ],
  },
  {
    tabId: assessmentTabIds.recommendations,
    tabName: "Priorities & Recommendations",
    componentsToPrint: [
      {
        name: "List View",
        component: PrioritiesRecsListExport,
      },
      { name: "Table View", component: PrioritiesRecsTableExport },
    ],
  },
  // {
  //   tabId: assessmentTabIds.platformInsights,
  //   tabName: "Platform Insights",
  //   componentsToPrint: [
  //     {
  //       name: "Platform Insights",
  //       component: PlatformInsightsExport,
  //     },
  //   ],
  // },
  // {
  //   tabId: assessmentTabIds.capabilityInsights,
  //   tabName: "Capability Insights",
  //   componentsToPrint: [
  //     {
  //       name: "Capability Insights",
  //       component: CapabilityInsightsExport,
  //     },
  //   ],
  // },
];

export const assessmentCapabilityChanges = {
  tabId: assessmentTabIds.capabilityChanges,
  tabName: "Capability Changes",
  componentsToPrint: [
    {
      name: "Capability Changes",
      component: CapabilityChangesExport,
    },
  ],
};

export const getSprV2AssessmentTabsAndExports = (): TabExportType[] => {
  return assessmentTabsAndExports.map((tab) => {
    if (tab.tabId === assessmentTabIds.recommendations) {
      return {
        ...tab,
        componentsToPrint: tab.componentsToPrint.filter(
          (c) => c.name === assessmentTabViewMode.list,
        ),
      };
    }
    return tab;
  });
};

export const getTpxAssessmentTabsAndExports = (vsemData?: { recommendationStatus?: string; isPublished?: boolean }): TabExportType[] => {
  const isMaturityChartReady = vsemData?.recommendationStatus === VsemRecommendationStatus.Succeeded;
  const isRecommendationsReady = vsemData?.isPublished === true;

  return [
    {
      tabId: assessmentTabIds.overview,
      tabName: "V.S.E.M.",
      componentsToPrint: [],
    },
    {
      tabId: assessmentTabIds.maturityChart,
      tabName: "Execution Areas",
      // Execution Areas enabled only after VSEM completion succeeds
      tabDisabled: !isMaturityChartReady,
      componentsToPrint: [],
    },
    {
      tabId: assessmentTabIds.recommendations,
      tabName: "Priorities & Recommendations",
      // Recommendations tab enabled only after assessment is published
      tabDisabled: !isRecommendationsReady,
      componentsToPrint: [],
    },
  ];
};

export const getAssessmentTabsAndExports = (
  isSprV2: boolean = false,
  showCapabilityChanges: boolean = false,
): TabExportType[] => {
  let tabs = isSprV2
    ? getSprV2AssessmentTabsAndExports()
    : [...assessmentTabsAndExports];

  if (showCapabilityChanges) {
    tabs.push(assessmentCapabilityChanges);
  }

  return tabs;
};

export const assessmentTabComponentToPrint = (
  showCapabilityChanges?: boolean,
  isSprV2?: boolean,
) => {
  let componentList: ExportComponent[] = [];
  const modifiedAssessmentTabsAndExports = getAssessmentTabsAndExports(
    isSprV2 || false,
    showCapabilityChanges || false,
  );

  modifiedAssessmentTabsAndExports.forEach((tab) =>
    componentList.push(...tab.componentsToPrint),
  );
  return componentList;
};
